<div class="under-construction-modal under-construction-modal--shown" tabindex="-1" role="dialog" id="app-construction-modal">
  <div class="under-construction-modal__dialog" role="document">
    <div class="under-construction-modal__content">
      <div class="under-construction-modal__header">
        <button
          type="button"
          class="under-construction-modal__close"
          aria-label="Close"
          (click)="close()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="under-construction-modal__title">
          {{ title }}
        </h4>
      </div>
      <div class="under-construction-modal__body">
        <img
          src="assets/images/construction.gif"
          alt="under construction"
          class="under-construction-modal__image"
        />
      </div>
      <div class="under-construction-modal__footer">
        <app-cmn-button
          type="button"
          variant="secondary"
          size="small"
          (buttonClick)="close()"
        >
          Close
        </app-cmn-button>
      </div>
    </div>
  </div>
</div>
